const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/SynedraViewerCard/SynedraViewerCard.tsx';
import { useDispatch } from 'react-redux';
import textMap from './translations';
import * as React from 'react';
import { useEffect } from 'react';
import { actionLoadSynedraToken } from 'App/actions/synedra';
import { useSynedraToken } from 'App/store/synedra';
import { DashboardCard } from '../DashboardCard';
import { CardNavigationLink } from '../CardNavigationLink';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';

type Props = {};

export const SynedraViewerCard = (props: Props) => {
    const dispatch = useDispatch();

    const { synedraCardTitle } = getConfiguration();

    const { data: synedraIFrameToken, isPendingOrLoading: isDataLoading } = useSynedraToken();
    const hasData = !!synedraIFrameToken?.iFrameUrl;

    useEffect(() => {
        dispatch(actionLoadSynedraToken());
    }, []);

    const handleClick = () => {
        window.open(synedraIFrameToken.iFrameUrl, '_blank', 'noreferrer');
    };

    return (
        <DashboardCard iconClass="icons8-x-ray" onClick={handleClick} isDataLoading={isDataLoading} hasData={hasData}>
            <CardNavigationLink text={synedraCardTitle || textMap.cardTitle} />
        </DashboardCard>
    );
};
